import { Sizes, } from './types';

export const cleanMediaQuery = (media: string) => media.replace(/^@media /, '');

export const getSize = (size: string, separator = 'x') => {
    const [ height, weight, ] = size.split(separator);

    return {
        height,
        weight,
    };
};

export const convertSizesToHtmlFormat = (sizes: Sizes) => Object
    .entries(sizes)
    .map(([ media, size ]) => `${cleanMediaQuery(media)} ${size}`)
    .join(',');
